import MagioreSignature1 from '../../../Media/Ruko Paramount/Magiore Signature/Magiore Signature (1).webp'
import MagioreSignature2 from '../../../Media/Ruko Paramount/Magiore Signature/Magiore Signature (2).webp'
import MagioreSignature3 from '../../../Media/Ruko Paramount/Magiore Signature/Magiore Signature (3).webp'


const MagioreSignatureimages =[
MagioreSignature1,MagioreSignature2,MagioreSignature3
]

export default MagioreSignatureimages;
